import { useState } from 'react';
import {
  GraduationCap,
  Search,
  UserPlus,
  Download,
  Pencil,
  Trash2,
  Star,
  BookOpen,
  Users,
  DollarSign,
  ArrowLeft,
} from 'lucide-react';
import { toast } from 'react-toastify';
import axios from 'axios';
import { host } from '../../api/ApiCalls';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';

pdfMake.vfs = pdfFonts.vfs;

const iconMap = {
  Users,
  DollarSign,
  BookOpen,
  GraduationCap,
  // aur icons yahan add karte jao
};

function StatCard({ title, value, change, icon: Icon, trend }) {
  console.log('StatCard props:', { title, value, change, Icon, trend });
  return (
    <div className="rounded-xl border bg-white shadow-md p-4">
      <div className="flex items-center justify-between">
        <h3 className="text-sm font-medium text-gray-800">{title}</h3>
        <Icon className="h-5 w-5 text-indigo-500" />
      </div>
      <div className="mt-2">
        <p className="text-2xl font-bold text-gray-900">{value}</p>
        <p
          className={`text-xs ${
            trend === 'up' ? 'text-green-500' : 'text-red-500'
          }`}
        >
          {change}
        </p>
      </div>
    </div>
  );
}

// Mock data
// const mockTeachers = [
//   {
//     id: 1,
//     name: "Dr. Sarah Johnson",
//     email: "sarah@example.com",
//     subject: "Mathematics",
//     rating: 4.8,
//     students: 45,
//     experience: "8 years",
//     // qualifications: ["Ph.D. Mathematics", "M.Sc. Mathematics"],
//     courses: ["Advanced Calculus", "Linear Algebra"]
//   },
//   {
//     id: 2,
//     name: "Prof. Michael Brown",
//     email: "michael@example.com",
//     subject: "Physics",
//     rating: 4.6,
//     students: 38,
//     experience: "12 years",
//     status: "Active",
//     lastActive: "1 hour ago",
//     qualifications: ["Ph.D. Physics", "M.Sc. Physics"],
//     courses: ["Quantum Mechanics", "Classical Mechanics"]
//   }
// ]

export default function TeacherManagement({
  component,
  setComponent,
  teachers,
  stats,
  setTeachers,
}) {
  // const [teachers, setTeachers] = useState(mockTeachers)
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedSubject, setSelectedSubject] = useState('All Subjects');
  const [selectedStatus, setSelectedStatus] = useState('All Status');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingTeacher, setEditingTeacher] = useState(null);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [teacherToDelete, setTeacherToDelete] = useState(null);
  const [dateFilter, setDateFilter] = useState('');
  const [downloadOption, setDownloadOption] = useState(''); // Track dropdown state

  // // Stats data
  // const stats = [
  //   {
  //     title: "Total Teachers",
  //     value: teachers.length,
  //     change: "+5.2%",
  //     icon: GraduationCap,
  //     color: "text-purple-600",
  //     trend: "up"
  //   },
  //   {
  //     title: "Active Courses",
  //     value: teachers.reduce((acc, teacher) => acc + teacher.courses.length, 0),
  //     change: "+8.1%",
  //     icon: BookOpen,
  //     color: "text-blue-600",
  //     trend: "up"
  //   },
  //   {
  //     title: "Total Students",
  //     value: teachers.reduce((acc, teacher) => acc + teacher.students, 0),
  //     change: "+12.5%",
  //     icon: Users,
  //     color: "text-green-600",
  //     trend: "up"
  //   },
  //   {
  //     title: "Average Rating",
  //     value: (teachers.reduce((acc, teacher) => acc + teacher.rating, 0) / teachers.length).toFixed(1),
  //     change: "+3.2%",
  //     icon: Star,
  //     color: "text-yellow-600",
  //     trend: "up"
  //   }
  // ]

  // Handle teacher deletion
  const handleDeleteTeacher = (teacher) => {
    setTeacherToDelete(teacher);
    setShowDeleteConfirm(true);
  };

  const confirmDelete = async () => {
    try {
      const res = await axios.delete(
        `${host}/api/teachers/${teacherToDelete.id}`
      );
      if (res.status === 200) {
        setTeachers(teachers.filter((t) => t.id !== teacherToDelete.id));
        setShowDeleteConfirm(false);
        setTeacherToDelete(null);
        toast.success(`Teacher ${teacherToDelete.name} deleted successfully`);
      }
    } catch (err) {
      console.error('Error deleting teacher:', err);
      toast.error(`Error deleting teacher ${teacherToDelete.name}`);
    }
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;
    const name = form.name.value;
    const email = form.email.value;

    try {
      const response = await axios.put(
        `${host}/api/teachers/${editingTeacher.id}`, // Use correct teacher ID
        { name, email }
      );

      if (response.status === 200) {
        // Update teacher list
        setTeachers((prevTeachers) =>
          prevTeachers.map((teacher) =>
            teacher._id === editingTeacher._id ? response.data : teacher
          )
        );
        toast.success('Teacher updated successfully');
      }
    } catch (error) {
      console.error('Failed to update teacher:', error);
      toast.error('Failed to update teacher');
    } finally {
      setIsModalOpen(false);
      setEditingTeacher(null);
      form.reset();
    }
  };
  const downloadTeachersAsPDF = (teachers) => {
    const docDefinition = {
      pageSize: 'A4',
      pageOrientation: 'landscape',
      pageMargins: [25, 35, 25, 40],

      // Header section
      header: {
        margin: [25, 15, 25, 0],
        table: {
          widths: ['*', 'auto'],
          body: [
            [
              {
                stack: [
                  { text: 'AcademiaHub', style: 'headerCompany' },
                  {
                    text: 'Educational Management System',
                    style: 'headerSubtitle',
                  },
                ],
                margin: [0, 5, 0, 0],
              },
              {
                stack: [
                  { text: 'TEACHER REPORT', style: 'headerTitle' },
                  {
                    text: `Generated: ${new Date().toLocaleDateString('en-US', {
                      year: 'numeric',
                      month: 'long',
                      day: 'numeric',
                      hour: '2-digit',
                      minute: '2-digit',
                    })}`,
                    style: 'headerDate',
                  },
                ],
                alignment: 'right',
                margin: [0, 5, 0, 0],
              },
            ],
          ],
        },
        layout: 'noBorders',
      },

      content: [
        // Summary section
        {
          margin: [0, 20, 0, 15],
          table: {
            widths: ['*', '*', '*', '*'],
            body: [
              [
                { text: 'Total Teachers', style: 'summaryLabel' },
                { text: 'Active Instructors', style: 'summaryLabel' },
                { text: 'Total Students', style: 'summaryLabel' },
                { text: 'Average Class Size', style: 'summaryLabel' },
              ],
              [
                { text: teachers.length.toString(), style: 'summaryValue' },
                {
                  text: teachers
                    .filter((t) => t.courses && t.courses.length > 0)
                    .length.toString(),
                  style: 'summaryValue',
                },
                {
                  text: teachers
                    .reduce((acc, t) => acc + (t.students || 0), 0)
                    .toString(),
                  style: 'summaryValue',
                },
                {
                  text:
                    teachers.length > 0
                      ? Math.round(
                          teachers.reduce(
                            (acc, t) => acc + (t.students || 0),
                            0
                          ) / teachers.length
                        ).toString()
                      : '0',
                  style: 'summaryValue',
                },
              ],
            ],
          },
          layout: {
            fillColor: (rowIndex) => (rowIndex === 0 ? '#34495e' : '#ecf0f1'),
            textColor: (rowIndex) => (rowIndex === 0 ? 'white' : '#2c3e50'),
            hLineWidth: () => 0,
            vLineWidth: () => 0,
            paddingLeft: () => 8,
            paddingRight: () => 8,
            paddingTop: () => 6,
            paddingBottom: () => 6,
          },
        },

        { text: '\n' },

        // Main data table
        {
          table: {
            headerRows: 1,
            widths: [30, 140, 90, 70, 50, 60, '*'],
            body: [
              [
                { text: 'ID', style: 'tableHeader' },
                { text: 'Teacher Information', style: 'tableHeader' },
                { text: 'Username', style: 'tableHeader' },
                { text: 'Join Date', style: 'tableHeader' },
                { text: 'Status', style: 'tableHeader' },
                { text: 'Students/Courses', style: 'tableHeader' },
                { text: 'Teaching Assignments', style: 'tableHeader' },
              ],
              ...teachers.map((teacher, index) => [
                {
                  text: String(index + 1).padStart(3, '0'),
                  style: 'cellData',
                  alignment: 'center',
                  fillColor: '#f8f9fa',
                },
                {
                  stack: [
                    { text: teacher.name || 'Unknown', style: 'teacherName' },
                    {
                      text: teacher.email || 'No email',
                      style: 'teacherEmail',
                    },
                  ],
                  margin: [4, 3, 4, 3],
                },
                {
                  text: teacher.username || 'N/A',
                  style: 'cellData',
                  alignment: 'left',
                },
                {
                  stack: [
                    { text: teacher.dateJoined || 'N/A', style: 'dateText' },
                    { text: teacher.timeJoined || '', style: 'timeText' },
                  ],
                  alignment: 'center',
                },
                {
                  text:
                    teacher.courses && teacher.courses.length > 0
                      ? 'Active'
                      : 'Inactive',
                  style:
                    teacher.courses && teacher.courses.length > 0
                      ? 'statusActive'
                      : 'statusInactive',
                  alignment: 'center',
                  margin: [2, 4, 2, 4],
                },
                {
                  stack: [
                    {
                      text: `Students: ${teacher.students || 0}`,
                      style: 'statsText',
                    },
                    {
                      text: `Courses: ${teacher.totalCourses || 0}`,
                      style: 'statsText',
                    },
                  ],
                  alignment: 'center',
                  fillColor: '#e8f4fd',
                  margin: [2, 2, 2, 2],
                },
                {
                  text:
                    teacher.courses && teacher.courses.length > 0
                      ? teacher.courses
                          .map((course) => `• ${course}`)
                          .join('\n')
                      : 'No teaching assignments',
                  style:
                    teacher.courses && teacher.courses.length > 0
                      ? 'courseList'
                      : 'noCourses',
                  margin: [4, 2, 4, 2],
                },
              ]),
            ],
          },
          layout: {
            fillColor: (rowIndex, node) => {
              if (rowIndex === 0) return '#2c3e50';
              return rowIndex % 2 === 0 ? '#fdfdfd' : null;
            },
            textColor: (rowIndex) => (rowIndex === 0 ? 'white' : '#2c3e50'),
            hLineColor: '#bdc3c7',
            vLineColor: '#bdc3c7',
            hLineWidth: (i, node) =>
              i === 0 || i === node.table.body.length ? 1 : 0.5,
            vLineWidth: () => 0.5,
            paddingLeft: () => 4,
            paddingRight: () => 4,
            paddingTop: () => 4,
            paddingBottom: () => 4,
          },
        },
      ],

      // Footer
      footer: (currentPage, pageCount) => {
        return {
          margin: [25, 10, 25, 0],
          table: {
            widths: ['*', 'auto', '*'],
            body: [
              [
                {
                  text: 'AcademiaHub Educational Management System',
                  style: 'footerLeft',
                },
                {
                  text: `Page ${currentPage} of ${pageCount}`,
                  style: 'footerCenter',
                },
                {
                  text: '© 2025 - Confidential Document',
                  style: 'footerRight',
                },
              ],
            ],
          },
          layout: 'noBorders',
        };
      },

      styles: {
        // Header styles
        headerCompany: {
          fontSize: 18,
          bold: true,
          color: '#2c3e50',
          letterSpacing: 0.5,
        },
        headerSubtitle: {
          fontSize: 9,
          color: '#7f8c8d',
          italics: true,
          margin: [0, 2, 0, 0],
        },
        headerTitle: {
          fontSize: 16,
          bold: true,
          color: '#2c3e50',
          letterSpacing: 1,
        },
        headerDate: {
          fontSize: 8,
          color: '#7f8c8d',
          margin: [0, 3, 0, 0],
        },

        // Summary styles
        summaryLabel: {
          fontSize: 9,
          bold: true,
          alignment: 'center',
          margin: [0, 2, 0, 2],
        },
        summaryValue: {
          fontSize: 14,
          bold: true,
          alignment: 'center',
          margin: [0, 2, 0, 2],
        },

        // Table styles
        tableHeader: {
          fontSize: 9,
          bold: true,
          alignment: 'center',
          margin: [0, 4, 0, 4],
          color: 'white',
        },
        cellData: {
          fontSize: 8,
          margin: [2, 2, 2, 2],
          lineHeight: 1.2,
        },
        teacherName: {
          fontSize: 9,
          bold: true,
          color: '#2c3e50',
          margin: [0, 0, 0, 1],
        },
        teacherEmail: {
          fontSize: 7,
          color: '#7f8c8d',
          italics: true,
        },
        dateText: {
          fontSize: 8,
          bold: true,
          color: '#2c3e50',
        },
        timeText: {
          fontSize: 7,
          color: '#95a5a6',
          margin: [0, 1, 0, 0],
        },
        statusActive: {
          fontSize: 8,
          bold: true,
          color: '#27ae60',
          fillColor: '#d5f4e6',
          margin: [0, 2, 0, 2],
        },
        statusInactive: {
          fontSize: 8,
          bold: true,
          color: '#e74c3c',
          fillColor: '#fadbd8',
          margin: [0, 2, 0, 2],
        },
        statsText: {
          fontSize: 7,
          color: '#2980b9',
          bold: true,
          margin: [0, 1, 0, 1],
        },
        courseList: {
          fontSize: 7,
          lineHeight: 1.3,
          color: '#34495e',
        },
        noCourses: {
          fontSize: 7,
          italics: true,
          color: '#95a5a6',
          alignment: 'center',
        },

        // Footer styles
        footerLeft: {
          fontSize: 8,
          color: '#7f8c8d',
          alignment: 'left',
        },
        footerCenter: {
          fontSize: 8,
          color: '#2c3e50',
          bold: true,
          alignment: 'center',
        },
        footerRight: {
          fontSize: 8,
          color: '#7f8c8d',
          alignment: 'right',
        },
      },
    };

    // Generate and download the PDF
    pdfMake.createPdf(docDefinition).download('AcademiaHub_Teacher_Report.pdf');
  };

  // Enhanced version with detailed course breakdown for large datasets
  const downloadTeachersAsPDFEnhanced = (teachers) => {
    // Split teachers into chunks if there are too many
    const teachersPerPage = 20;
    const chunks = [];
    for (let i = 0; i < teachers.length; i += teachersPerPage) {
      chunks.push(teachers.slice(i, i + teachersPerPage));
    }

    const docDefinition = {
      pageSize: 'A4',
      pageOrientation: 'landscape',
      pageMargins: [20, 30, 20, 35],

      content: [
        // Title page
        {
          stack: [
            {
              text: 'AcademiaHub',
              style: 'titlePage',
              alignment: 'center',
              margin: [0, 50, 0, 10],
            },
            {
              text: 'Teacher Comprehensive Report',
              style: 'titlePageSub',
              alignment: 'center',
              margin: [0, 0, 0, 20],
            },
            {
              text: `Generated on ${new Date().toLocaleDateString('en-US', {
                weekday: 'long',
                year: 'numeric',
                month: 'long',
                day: 'numeric',
              })}`,
              style: 'titlePageDate',
              alignment: 'center',
              margin: [0, 0, 0, 30],
            },

            // Executive Summary for Teachers
            {
              text: 'Faculty Overview',
              style: 'sectionTitle',
              margin: [0, 20, 0, 10],
            },
            {
              ul: [
                `Total Faculty Members: ${teachers.length}`,
                `Active Instructors: ${
                  teachers.filter((t) => t.courses && t.courses.length > 0)
                    .length
                }`,
                `Total Students Taught: ${teachers.reduce(
                  (acc, t) => acc + (t.students || 0),
                  0
                )}`,
                `Total Course Offerings: ${teachers.reduce(
                  (acc, t) => acc + (t.totalCourses || 0),
                  0
                )}`,
                `Average Students per Teacher: ${
                  teachers.length > 0
                    ? Math.round(
                        teachers.reduce(
                          (acc, t) => acc + (t.students || 0),
                          0
                        ) / teachers.length
                      )
                    : 0
                }`,
              ],
              style: 'summaryList',
            },

            // Department breakdown if available
            {
              text: '\nTeaching Load Distribution',
              style: 'sectionTitle',
              margin: [0, 15, 0, 10],
            },
            {
              table: {
                widths: ['*', '*', '*'],
                body: [
                  [
                    { text: 'Load Category', style: 'miniTableHeader' },
                    { text: 'Teachers', style: 'miniTableHeader' },
                    { text: 'Percentage', style: 'miniTableHeader' },
                  ],
                  [
                    { text: 'Heavy Load (3+ courses)', style: 'miniTableCell' },
                    {
                      text: teachers
                        .filter((t) => (t.totalCourses || 0) >= 3)
                        .length.toString(),
                      style: 'miniTableCell',
                    },
                    {
                      text: `${Math.round(
                        (teachers.filter((t) => (t.totalCourses || 0) >= 3)
                          .length /
                          teachers.length) *
                          100
                      )}%`,
                      style: 'miniTableCell',
                    },
                  ],
                  [
                    {
                      text: 'Moderate Load (1-2 courses)',
                      style: 'miniTableCell',
                    },
                    {
                      text: teachers
                        .filter(
                          (t) =>
                            (t.totalCourses || 0) >= 1 &&
                            (t.totalCourses || 0) < 3
                        )
                        .length.toString(),
                      style: 'miniTableCell',
                    },
                    {
                      text: `${Math.round(
                        (teachers.filter(
                          (t) =>
                            (t.totalCourses || 0) >= 1 &&
                            (t.totalCourses || 0) < 3
                        ).length /
                          teachers.length) *
                          100
                      )}%`,
                      style: 'miniTableCell',
                    },
                  ],
                  [
                    { text: 'No Active Teaching', style: 'miniTableCell' },
                    {
                      text: teachers
                        .filter((t) => (t.totalCourses || 0) === 0)
                        .length.toString(),
                      style: 'miniTableCell',
                    },
                    {
                      text: `${Math.round(
                        (teachers.filter((t) => (t.totalCourses || 0) === 0)
                          .length /
                          teachers.length) *
                          100
                      )}%`,
                      style: 'miniTableCell',
                    },
                  ],
                ],
              },
              layout: {
                fillColor: (rowIndex) =>
                  rowIndex === 0
                    ? '#34495e'
                    : rowIndex % 2 === 0
                    ? '#f8f9fa'
                    : null,
                textColor: (rowIndex) => (rowIndex === 0 ? 'white' : '#2c3e50'),
                hLineWidth: () => 0.5,
                vLineWidth: () => 0.5,
                hLineColor: '#bdc3c7',
                vLineColor: '#bdc3c7',
              },
            },
          ],
          pageBreak: 'after',
        },

        // Data tables for each chunk
        ...chunks.map((chunk, chunkIndex) => ({
          stack: [
            {
              text: `Faculty Details - Section ${chunkIndex + 1}`,
              style: 'pageTitle',
              margin: [0, 0, 0, 15],
            },
            {
              table: {
                headerRows: 1,
                widths: [25, 130, 80, 65, 45, 65, '*'],
                body: [
                  [
                    { text: 'ID', style: 'tableHeaderEnhanced' },
                    {
                      text: 'Faculty Information',
                      style: 'tableHeaderEnhanced',
                    },
                    { text: 'Username', style: 'tableHeaderEnhanced' },
                    { text: 'Join Date', style: 'tableHeaderEnhanced' },
                    { text: 'Status', style: 'tableHeaderEnhanced' },
                    { text: 'Teaching Load', style: 'tableHeaderEnhanced' },
                    {
                      text: 'Course Assignments',
                      style: 'tableHeaderEnhanced',
                    },
                  ],
                  ...chunk.map((teacher, index) => [
                    {
                      text: String(
                        chunkIndex * teachersPerPage + index + 1
                      ).padStart(3, '0'),
                      style: 'cellEnhanced',
                      alignment: 'center',
                      fillColor: '#f1f2f6',
                    },
                    {
                      stack: [
                        {
                          text: teacher.name || 'Unknown Faculty',
                          style: 'nameEnhanced',
                        },
                        {
                          text: teacher.email || 'No email provided',
                          style: 'emailEnhanced',
                        },
                      ],
                      margin: [3, 2, 3, 2],
                    },
                    {
                      text: teacher.username || 'Not assigned',
                      style: 'cellEnhanced',
                    },
                    {
                      text: teacher.dateJoined || 'Unknown',
                      style: 'cellEnhanced',
                      alignment: 'center',
                    },
                    {
                      text:
                        teacher.courses && teacher.courses.length > 0
                          ? 'ACTIVE'
                          : 'INACTIVE',
                      style:
                        teacher.courses && teacher.courses.length > 0
                          ? 'activeStatus'
                          : 'inactiveStatus',
                      alignment: 'center',
                    },
                    {
                      stack: [
                        {
                          text: `Students: ${teacher.students || 0}`,
                          style: 'loadText',
                        },
                        {
                          text: `Courses: ${teacher.totalCourses || 0}`,
                          style: 'loadText',
                        },
                      ],
                      alignment: 'center',
                      fillColor: '#fff3cd',
                    },
                    {
                      text:
                        teacher.courses && teacher.courses.length > 0
                          ? teacher.courses.join(' • ')
                          : 'No active assignments',
                      style:
                        teacher.courses && teacher.courses.length > 0
                          ? 'coursesEnhanced'
                          : 'noCoursesEnhanced',
                      margin: [3, 2, 3, 2],
                    },
                  ]),
                ],
              },
              layout: {
                fillColor: (rowIndex) => {
                  if (rowIndex === 0) return '#2f3640';
                  return rowIndex % 2 === 0 ? '#f8f9fa' : null;
                },
                textColor: (rowIndex) => (rowIndex === 0 ? 'white' : '#2c3e50'),
                hLineColor: '#ced6e0',
                vLineColor: '#ced6e0',
                hLineWidth: () => 0.5,
                vLineWidth: () => 0.5,
                paddingLeft: () => 4,
                paddingRight: () => 4,
                paddingTop: () => 3,
                paddingBottom: () => 3,
              },
            },
          ],
          pageBreak: chunkIndex < chunks.length - 1 ? 'after' : undefined,
        })),
      ],

      footer: (currentPage, pageCount) => ({
        margin: [20, 0, 20, 0],
        table: {
          widths: ['*', 'auto', '*'],
          body: [
            [
              {
                text: 'AcademiaHub © 2025',
                style: 'footerEnhanced',
                alignment: 'left',
              },
              {
                text: `${currentPage} / ${pageCount}`,
                style: 'footerPageEnhanced',
              },
              {
                text: 'Faculty Confidential Report',
                style: 'footerEnhanced',
                alignment: 'right',
              },
            ],
          ],
        },
        layout: 'noBorders',
      }),

      styles: {
        titlePage: { fontSize: 24, bold: true, color: '#2c3e50' },
        titlePageSub: { fontSize: 16, color: '#7f8c8d', italics: true },
        titlePageDate: { fontSize: 12, color: '#95a5a6' },
        sectionTitle: { fontSize: 14, bold: true, color: '#2c3e50' },
        summaryList: { fontSize: 11, margin: [20, 5, 0, 5] },
        pageTitle: { fontSize: 14, bold: true, color: '#2c3e50' },
        miniTableHeader: {
          fontSize: 9,
          bold: true,
          alignment: 'center',
          margin: [2, 3, 2, 3],
        },
        miniTableCell: {
          fontSize: 8,
          alignment: 'center',
          margin: [2, 2, 2, 2],
        },
        tableHeaderEnhanced: {
          fontSize: 9,
          bold: true,
          alignment: 'center',
          margin: [0, 3, 0, 3],
        },
        cellEnhanced: { fontSize: 8, margin: [1, 1, 1, 1] },
        nameEnhanced: { fontSize: 9, bold: true, color: '#2c3e50' },
        emailEnhanced: {
          fontSize: 7,
          color: '#7f8c8d',
          italics: true,
          margin: [0, 1, 0, 0],
        },
        loadText: {
          fontSize: 7,
          color: '#f39c12',
          bold: true,
          margin: [0, 1, 0, 1],
        },
        activeStatus: {
          fontSize: 7,
          bold: true,
          color: '#27ae60',
          fillColor: '#d5f4e6',
        },
        inactiveStatus: {
          fontSize: 7,
          bold: true,
          color: '#e74c3c',
          fillColor: '#fadbd8',
        },
        coursesEnhanced: { fontSize: 7, lineHeight: 1.2, color: '#34495e' },
        noCoursesEnhanced: {
          fontSize: 7,
          italics: true,
          color: '#bdc3c7',
          alignment: 'center',
        },
        footerEnhanced: { fontSize: 8, color: '#7f8c8d' },
        footerPageEnhanced: { fontSize: 9, bold: true, color: '#2c3e50' },
      },
    };

    pdfMake
      .createPdf(docDefinition)
      .download('AcademiaHub_Enhanced_Teacher_Report.pdf');
  };

  // Usage:
  // downloadTeachersAsPDF(teachersData);           // Standard professional version
  // downloadTeachersAsPDFEnhanced(teachersData);   // Enhanced version for large datasets

  // Alternative approach: Split into multiple tables if data is still too wide

  // Usage examples:
  // For single table approach:
  // downloadTeachersAsPDF(teachersData);

  // For split table approach (recommended for wide data):
  // downloadTeachersAsPDFSplit(teachersData);

  const handleCSVDownload = () => {
    if (!teachers || teachers.length === 0) {
      alert('No student data to export.');
      return;
    }

    const headers = Object.keys(teachers[0]); // Get column names

    const csvRows = [
      headers.join(','), // Header row
      ...teachers.map((teacher) =>
        headers
          .map((field) => {
            const value = teacher[field] ?? ''; // Fallback to empty if undefined/null
            return `"${String(value).replace(/"/g, '""')}"`; // Escape quotes
          })
          .join(',')
      ),
    ];

    const csv = csvRows.join('\n');
    const blob = new Blob([csv], {
      type: 'text/csv;charset=utf-8;',
    });
    const url = URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = 'teachers.csv';
    a.click();

    URL.revokeObjectURL(url); // Clean up
  };
  // const now = new Date();

  const getFilteredDate = (filter) => {
    const now = new Date();
    switch (filter) {
      case 'lastWeek':
        // return new Date(now.setDate(now.getDate() - 7));
        return new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);
      case 'lastMonth':
        // return new Date(now.setMonth(now.getMonth() - 1));
        const lastMonth = new Date(now);
        lastMonth.setMonth(now.getMonth() - 1);
        return lastMonth;
      case 'last3Months':
        // return new Date(now.setMonth(now.getMonth() - 3));
        const last3Months = new Date(now);
        last3Months.setMonth(now.getMonth() - 3);
        return last3Months;
      case 'last6Months':
        // return new Date(now.setMonth(now.getMonth() - 6));
        const last6Months = new Date(now);
        last6Months.setMonth(now.getMonth() - 6);
        return last6Months;
      default:
        return null;
    }
  };

  const filteredTeachers = teachers.filter((teacher) => {
    const matchesSearch =
      teacher.name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      teacher.email?.toLowerCase().includes(searchQuery.toLowerCase());

    const matchesSubject =
      selectedSubject === 'All Subjects' || teacher.subject === selectedSubject;
    const matchesStatus =
      selectedStatus === 'All Status' || teacher.status === selectedStatus;

    // If no date filter is applied, simply return other matches
    if (!dateFilter) {
      return matchesSearch && matchesSubject && matchesStatus;
    }

    // Apply date filter if provided
    const filterDate = getFilteredDate(dateFilter);
    const teacherDate = new Date(teacher.dateJoined); // Ensure the date is in a proper format

    return (
      matchesSearch &&
      matchesSubject &&
      matchesStatus &&
      teacherDate >= filterDate
    );
  });
  const handleDownloadChange = (e) => {
    const value = e.target.value;
    setDownloadOption(''); // Reset dropdown after selection

    if (value === 'csv') {
      handleCSVDownload();
    } else if (value === 'pdf') {
      downloadTeachersAsPDF(filteredTeachers);
    }
  };

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="space-y-6 p-6 bg-gray-50 min-h-screen">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-6">
  <h2 className="text-2xl md:text-3xl font-bold tracking-tight text-gray-800 flex items-center">
    <button
      className="p-2 hover:bg-gray-100 rounded mr-2"
      onClick={() => setComponent('AdminDashboard')}
    >
      <ArrowLeft className="h-6 w-6 text-gray-500" />
    </button>
    <Users className="inline-block mr-2" />
    Teacher Management
  </h2>

  <div className="w-full md:w-auto">
    <select
      onChange={handleDownloadChange}
      value={downloadOption}
      className="w-full md:w-auto bg-indigo-500 text-white font-bold py-2 px-4 rounded cursor-pointer"
    >
      <option value="" disabled className="text-black bg-white border-bottom">
        Select download format
      </option>
      <option value="csv" className="text-black bg-white">
        Download as CSV
      </option>
      <option value="pdf" className="text-black bg-white">
        Download as PDF
      </option>
    </select>
  </div>
</div>

        <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4 grid-rows-1">
          {stats.map((stat) => (
            <StatCard
              title={stat.title}
              value={stat.value}
              // change="+12.5% from last month"
              icon={iconMap[stat.icon]}
              // trend="up"
            />
          ))}
        </div>
        {/* Search and Filters */}
        <div className="flex flex-col md:flex-row gap-4">
          <div className="flex w-full items-center justify-between gap-4">
            {/* Search Input */}
            <div className="relative flex-1">
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
              <input
                type="text"
                placeholder="Search teachers..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="w-full pl-10 pr-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>

            {/* Date Filter */}
            <select
              value={dateFilter}
              onChange={(e) => setDateFilter(e.target.value)}
              className="border rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="">All Time</option>
              <option value="lastWeek">Last Week</option>
              <option value="lastMonth">Last Month</option>
              <option value="last3Months">Last 3 Months</option>
              <option value="last6Months">Last 6 Months</option>
            </select>
          </div>
        </div>

        {/* Teacher List */}
        <div className="bg-white rounded-lg shadow-sm overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  #
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Teacher
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Username
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Date Joined
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Time Joined
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Students
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Total Courses
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Courses
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {filteredTeachers.map((teacher, index) => (
                <tr key={teacher.id} className="hover:bg-gray-50">
                  <td className="px-6 py-4 text-sm text-gray-500">
                    {index + 1}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="flex items-center">
                      <div className="h-10 w-10 rounded-full bg-gray-200 flex items-center justify-center">
                        {teacher.avatar ? (
                          <img
                            src={teacher.avatar}
                            alt={teacher.name}
                            className="h-full w-full rounded-full object-cover"
                          />
                        ) : (
                          <span className="text-gray-600 font-medium">
                            {teacher.name.charAt(0)}
                          </span>
                        )}
                      </div>
                      <div className="ml-4">
                        <div className="text-sm font-medium text-gray-900">
                          {teacher.name}
                        </div>
                        <div className="text-sm text-gray-500">
                          {teacher.email}
                        </div>
                      </div>
                    </div>
                  </td>

                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    {teacher.username}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
                    {teacher.dateJoined}
                  </td>

                  {/* Time Joined */}
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
                    {teacher.timeJoined}
                  </td>

                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    {teacher.students}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    {teacher.totalCourses}
                  </td>

                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="flex flex-wrap gap-1">
                      {teacher.courses.map((course, index) => (
                        <span
                          key={index}
                          className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800"
                        >
                          {course}
                        </span>
                      ))}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    <div className="flex items-center gap-2">
                      <button
                        className="p-1 hover:bg-gray-100 rounded"
                        onClick={() => {
                          setEditingTeacher(teacher);
                          setIsModalOpen(true);
                        }}
                      >
                        <Pencil className="h-4 w-4 text-gray-500" />
                      </button>
                      <button
                        className="p-1 hover:bg-gray-100 rounded"
                        onClick={() => handleDeleteTeacher(teacher)}
                      >
                        <Trash2 className="h-4 w-4 text-red-500" />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Add/Edit Teacher Modal */}
      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
          <div className="bg-white rounded-lg p-6 w-full max-w-md">
            <h3 className="text-lg font-semibold mb-4">
              {editingTeacher ? 'Edit Teacher' : 'Add New Teacher'}
            </h3>

            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Full Name
                </label>
                <input
                  name="name"
                  type="text"
                  defaultValue={editingTeacher?.name}
                  className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 shadow-sm focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
                  placeholder="Enter full name"
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Email
                </label>
                <input
                  name="email"
                  type="email"
                  defaultValue={editingTeacher?.email}
                  className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 shadow-sm focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
                  placeholder="Enter email address"
                  required
                />
              </div>

              <div className="mt-6 flex justify-end gap-3">
                <button
                  type="button"
                  onClick={() => {
                    setIsModalOpen(false);
                    setEditingTeacher(null);
                  }}
                  className="px-4 py-2 border rounded-md text-gray-700 hover:bg-gray-50"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
                >
                  {editingTeacher ? 'Update' : 'Add'} Teacher
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Delete Confirmation Modal */}
      {showDeleteConfirm && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
          <div className="bg-white rounded-lg p-6 w-full max-w-sm">
            <h3 className="text-lg font-semibold mb-4">Confirm Delete</h3>
            <p className="text-gray-600 mb-6">
              Are you sure you want to delete {teacherToDelete.name}? This
              action cannot be undone.
            </p>
            <div className="flex justify-end gap-3">
              <button
                onClick={() => {
                  setShowDeleteConfirm(false);
                  setTeacherToDelete(null);
                }}
                className="px-4 py-2 border rounded-md text-gray-700 hover:bg-gray-50"
              >
                Cancel
              </button>
              <button
                onClick={confirmDelete}
                className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700"
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
